import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';


export const routes: Routes = [
  {
    path: 'anasayfa',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'anket/:lokasyonKey',
    loadChildren: () => import('./public-survey/public-survey.module').then(m => m.PublicSurveyModule),
  },
  // UUID doğrudan root path'de - UUID pattern'i kontrol et
  {
    matcher: (segments) => {
      if (segments.length === 1) {
        const segment = segments[0];
        // UUID format kontrolü (8-4-4-4-12 karakterlik hexadecimal)
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (uuidRegex.test(segment.path)) {
          return { consumed: segments, posParams: { lokasyonKey: segments[0] } };
        }
      }
      return null;
    },
    loadChildren: () => import('./public-survey/public-survey.module').then(m => m.PublicSurveyModule)
  },

  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
    ],
  },
  { path: '', redirectTo: 'anasayfa', pathMatch: 'full' },
  { path: '**', redirectTo: 'anasayfa' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
